<template>
  <div>
    <media v-for="(row, index) in dataList" :options="row"  v-if="row.type!=3"/>
    <!-- 分页 -->
    <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage"/>
  </div>
</template>

<script>
import media from "@/components/AuthorContent/mediaItem";
import page from "@/components/page/pages";
import {recommendLists} from "@/api/interfaceApi";
export default {
  components: {media, page},
  data() {
    return {
      pageNum: 1,
      dataList: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      cid:0,
    };
  },
  watch: {
    cityNo(e) {
      this.tablePage.currentPage=1;
      this.getCommercialLists();
    },
  },
  props: {
    cityNo: {
      type: [String, Number],
      default(){
        return  0
      }
    },
    cityList:{
      type: Object,
      default(){
        return  {}
      }
    },
  },
  mounted() {
    this.getCommercialLists();
  },
  methods: {
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getCommercialLists();
    },
    getCommercialLists() {
      recommendLists({
        advLat: this.cityList.lng,
        advLng: this.cityList.lat,
        advNetwork: 4,
        advPlatform: 3,
        city: this.cityList.id,
        nid: 1,
        page: this.tablePage.currentPage,
        uid: this.cid!=0 && this.cid!=undefined ? this.cid : 0,
        cid: this.cid!=0 && this.cid!=undefined ? this.cid : 0
      }).then(res=>{
        if (res.code==200){
          this.dataList=res.content;
          this.tablePage.total=res.total;
          window.scrollTo(0, 60);
        }
      })
    }
  },
  beforeMount() {
    this.cid=sessionStorage.getItem('loginData')!='' &&  sessionStorage.getItem('loginData')!=null && sessionStorage.getItem('loginData')!=undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>

<style lang="scss" scoped>
</style>